import GeneralHeader from 'components/common/GeneralHeader';
import HolidayTable from 'components/tables/holiday_table';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const PublicHolydays = () => {
  const navigate = useNavigate();
  return (
    <div>
      <GeneralHeader
        pageTitle="Public Holidays"
        btnComponent={
          <button
            onClick={() =>
              navigate('/staff_leave_&_absences/public_holidays/new_calendar')
            }
            className="header-button"
          >
            <img src="/icons/add_button.svg" alt="button" />
            New calendar
          </button>
        }
        icon="/icons/public_holiday.svg"
        child={
          <div>
            <div style={{ marginTop: '50px', paddingBottom: '100px' }}>
              <section className={'function_container'}>
                <div
                  style={{ background: 'white', padding: '10px 0px 10px 0px' }}
                  className={'function_wrapper'}
                >
                  <div>
                    <HolidayTable />
                  </div>
                </div>
              </section>
            </div>
          </div>
        }
      />
    </div>
  );
};

export default PublicHolydays;
